import { createStyles, makeStyles } from "@material-ui/core/styles";
import {
    AreaNotification,
    DataSection,
    domain,
    PhoneField,
    RelodeTheme,
    TextField,
} from "@relode/core";
import * as React from "react";
import { useSettingsContext } from "./_infra/settingsProvider";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                display: "flex",
                minHeight: "100%",
                flexDirection: "column",
                borderRadius: 1,
                flexGrow: 1,
                flexBasis: "100%",
                padding: theme.spacing(2),
                alignItems: "baseline",
            },
            input: {
                width: 250,
                margin: theme.spacing(1, 4, 0, 0),
            },
            section: {
                marginBottom: theme.spacing(3),
            },
            sectionColumn: {
                display: "flex",
                flexDirection: "column",
            },
        }),
    { name: "SettingsContact" }
);

export const Contact = () => {
    const baseId = "clientContact";

    const classes = useStyles({});
    const { contact } = useSettingsContext();

    if (!contact) return null;

    return (
        <div className={classes.root}>
            <AreaNotification areaName="saveError" />
            <DataSection
                baseId={`${baseId}ContactInfo`}
                className={classes.section}
            >
                <div className={classes.sectionColumn}>
                    <TextField
                        className={classes.input}
                        label="first name"
                        id="firstName"
                        name="firstName"
                        disabled={true}
                    />
                    <TextField
                        className={classes.input}
                        label="last name"
                        id="lastName"
                        name="lastName"
                        disabled={true}
                    />
                    <TextField
                        className={classes.input}
                        label="email"
                        id="email"
                        name="email"
                        disabled={true}
                    />
                    <PhoneField
                        type="phone"
                        className={classes.input}
                        label="phone number"
                        id="phoneNumber"
                        name="phoneNumber"
                        disabled={true}
                    />
                </div>
            </DataSection>
        </div>
    );
};
